import { render } from "./Contact.vue?vue&type=template&id=1f1b777d"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__